import { PageHero } from "@/components/site/PageParts";
import { Reveal } from "@/lib/motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  { q: "What is Doublelist?", a: "Doublelist is an adults-only social networking and personal classifieds platform operated by Interlaced Social LLC. It's a discreet space for consenting adults (18+) to connect on their own terms." },
  { q: "Do I have to be 18 or older?", a: "Yes. Doublelist is strictly for adults aged 18 and over. We require age confirmation and take active steps to keep minors off the platform. Any account involving a minor is removed immediately." },
  { q: "Are paid sexual services allowed?", a: "No. Offering, advertising, or soliciting paid sexual services is strictly prohibited. Doublelist is a community for genuine connection, not a marketplace for services." },
  { q: "How do you keep the platform safe?", a: "We enforce clear community rules, prohibit illegal content and harassment, provide reporting tools, and act quickly on reports. We also cooperate fully with lawful investigations." },
  { q: "How is my privacy protected?", a: "Discretion is central to our design. We minimise the data we collect, never sell your information, and give you control over your presence. See our Privacy Policy for full details." },
  { q: "What content is prohibited?", a: "Illegal content, paid sexual services, human trafficking, any involvement of minors, harassment, non-consensual content, impersonation, and sharing others' private information are all strictly forbidden." },
  { q: "How do I report something?", a: "Use in-platform reporting where available, or email us at space@interlacedsociial.com. In an emergency, always contact your local emergency services first." },
  { q: "How can I contact Interlaced Social LLC?", a: "You can reach us via the Contact page, by email at space@interlacedsociial.com, or by phone at +1 731-298-6768." },
];

export default function FAQ() {
  return (
    <div data-testid="faq-page">
      <PageHero
        index="E/"
        overline="FAQ"
        titleLines={["Questions,", <><span className="italic text-oxblood">answered</span></>]}
        intro="The essentials about Doublelist, safety, and how we operate."
      />

      <section className="mx-auto max-w-[900px] px-6 md:px-12 py-16 md:py-24">
        <Reveal>
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="border-b border-line"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger className="text-left font-serif text-2xl sm:text-3xl py-7 hover:no-underline hover:text-oxblood transition-colors">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-ink-soft leading-relaxed text-lg pb-8 max-w-2xl">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </section>
    </div>
  );
}
